import React from 'react';
import { string, bool, func } from 'prop-types';
import { TouchScrollable } from 'react-scrolllock-configurable';
import { Portal } from 'react-portal';

import { Wrap, Container } from './styled';

/**
 * Uses TouchScrollable component to allow scrolling within menu.
 */
const Mobile = ({ className, shouldShowMenu, handleClick, b2cRedirectionModal }) => (
    <Portal>
        <TouchScrollable>
            <Wrap shouldShow={shouldShowMenu}>
                <Container
                    b2cRedirectionModal={b2cRedirectionModal}
                    shouldShowMenu={shouldShowMenu}
                    handleClick={handleClick}
                    className={className}
                />
            </Wrap>
        </TouchScrollable>
    </Portal>
);

Mobile.propTypes = {
    className: string,
    shouldShowMenu: bool,
    handleClick: func,
};

Mobile.defaultProps = {
    className: '',
    shouldShowMenu: true,
    handleClick: () => {},
};

export default Mobile;
